import { entityTypes } from "../../static/types/objectType"
import reducedIndividualPersonValidationSchema from "../../utils/validation/reducedIndividualPersonValidationSchema"
import reducedLegalEntityValidationSchema from "../../utils/validation/reducedLegalEntityValidationScheme"
import ReducedIndividualPerson from "./ReducedIndividualPerson"
import ReducedLegalEntity from "./ReducedLegalEntity"
import { ReducedIndividualPersonType } from "../../static/types/commonTypes/reducedIndividualPersonType"
import { ReducedLegalEntityType } from "../../static/types/commonTypes/reducedLegalEntityType"
import { ReducedManagerType } from "../../static/types/commonTypes/reducedManagerType"
import { useDraftManager } from "../../hooks/useDraftManager"

type managerProps = {
    checked: boolean,
    manager: ReducedManagerType,
    draftFieldName?: string,
    setChecked: ( checked: boolean ) => void,
    setManager?: ( manager: ReducedManagerType | any ) => void,
    updateManagerValidity: ( isValid: boolean ) => void
}

export default function ReducedManager ({
    checked,
    manager,
    draftFieldName,
    setManager,
    setChecked,
    updateManagerValidity
}: managerProps ) {

    const { pushDraftContent } = useDraftManager()
    
    const updateEntityDetails = (details: Partial<ReducedIndividualPersonType | ReducedLegalEntityType>) => {
        if ( setManager ){
            setManager(  ( prev: any ) => {
                if (prev.person === "Personne physique") {
                    return { ...prev, personDetails: { ...prev.personDetails, ...details } };
                } else {
                    return { ...prev, entityDetails: { ...prev.entityDetails, ...details } };
                }
            });
            pushDraftContent({ [ draftFieldName || 'reducedManager' ]: manager })
        }
    };
    
    const handlePersonChange = (person: "Personne physique" | "Personne morale") => {
        if ( setManager ) {
            setManager( person === "Personne physique"
            ? { person, personDetails: reducedIndividualPersonValidationSchema }
            : { person, entityDetails: reducedLegalEntityValidationSchema });
        }
        setChecked( false )
        pushDraftContent({ [ draftFieldName || 'reducedManager' ]: manager })
    };

    return(
        <div className = "tab-content">

            <div className = "mb-3 row">
                <div className = "mb-3 row">
                    <label htmlFor="personne" className = "col-sm-2 col-form-label">Personne</label>
                    <div className = "col-sm-10">
                        <select
                            className = "form-select"
                            id = "person"
                            onChange = { e => handlePersonChange(e.target.value as "Personne physique" | "Personne morale") }
                            value = { manager?.person || "" }
                        >
                            {
                                entityTypes.map( option=> 
                                    <option key = { option } value = { option }>
                                        { option }
                                    </option>
                                )
                            }
                        </select>
                    </div>
                </div>
            </div>

            {
                manager.person === 'Personne physique' &&
                <ReducedIndividualPerson
                    checked = {checked}
                    reducedIndividualPerson = {manager.personDetails}
                    changeReducedIndividualPerson = {updateEntityDetails}
                    onValidationChange = {updateManagerValidity}
                />
            }

            {
                manager.person === 'Personne morale' &&
                <ReducedLegalEntity
                    checked = {checked}
                    reducedLegalEntity = {manager.entityDetails}
                    changeReducedLegalEntity = {updateEntityDetails}
                    onValidationChange = {updateManagerValidity}
                />
            }

        </div>
    )
}